import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'primeng/api';
import { SettingsService } from 'src/app/entities/settings/services/settings.service';
import { ArtToolsService } from '../services/art-tools.service';
import { Title } from '@angular/platform-browser';
import GlobalSearchResults from 'src/app/common/dtos/GlobalSearchResults';
import { GlobalSearchService } from 'src/app/common/services/global-search.service';
import { EntityViewService } from 'src/app/services/entity-view.service';
import { SpinnerService } from '../../../common/services/spinner.service';
import { UtilitiesService } from 'src/app/common/services/utilities.service';
import map from 'lodash/map';

@Component({
  selector: 'render-preview-tool',
  templateUrl: './render-preview-tool.component.html',
  styleUrls: ['./render-preview-tool.component.sass'],

})
export class RenderPreviewToolComponent implements OnInit {

  globalSearchQueryValue: string;
  options: Array<any> = [];
  currentTimeout: any;
  globalSearchSearchValue: string;
  challenge: any = {};
  suggestions: any = [];
  spawners: any = {};
  sceneRenderURL: string = "https://d3tfb94dc03jqa.cloudfront.net/thumbnails/thumbnail_placeholder.jpeg";
  urlPrefix: string = "https://flora-render.dev.petunia.gardenjoygame.com/renderserver/test"

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private settingsService: SettingsService,
    private artToolsService: ArtToolsService,
    private titleService: Title,
    private globalSearchService: GlobalSearchService,
    private entityViewService: EntityViewService,
    private spinnerService: SpinnerService,
    private utilitiesService: UtilitiesService
  ) {}

  isLoading: boolean;
  challengeFetched: boolean = false;

  /**
   * Component Initialiation
   */
  async ngOnInit()
  {
    this.titleService.setTitle('Render Preview');
    this.isLoading = false;
  }

  /**
   * Perform a search query on multiple entities.
   *
   * @param event The search query value
   */
  async globalSearch(event: any)
  {
    this.globalSearchSearchValue = event.query;
    if (this.currentTimeout)
    {
      clearTimeout(this.currentTimeout);
    }

    this.currentTimeout = setTimeout(async () =>
    {
      let response = await this.globalSearchService.challengeSearch(event.query);
      if(response && response.challenges)
      {
        console.log(response);
        this.options = response.challenges;
      }
      this.currentTimeout = null;
    }, 500);
  }

  /**
   * Handle Slected option from dropdownd
   *
   * @param event PrimeNG select event ({ originalEvent, value }) or the selected entity
   */
  async onSelectedEntity(event: any)
  {
    // PrimeNG's AutoComplete emits { originalEvent, value }. Reading `id` off the event
    // itself yields undefined, which JSON drops from the request body, leaving an empty
    // query that resolves to the first challenge in the collection instead of the
    // selected one.
    const selectedValue = event?.value ?? event;

    if(selectedValue?.id)
    {
      this.spinnerService.loadSpinner();

      // Drop the spawner selection of a previously previewed scene, otherwise its
      // items leak into the render URL built for this one.
      this.spawners = {};
      this.challengeFetched = false;

      // once user selects a challenge we need to get the whole challenge
      await this.entityViewService.getEntity('challenges', { query: { id: selectedValue.id } }).then(async (data: any) => {
        if(!data)
        {
          this.spinnerService.endSpinner();
          this.messageService.add({
            severity: 'error',
            summary: 'Scene Not Found',
            detail: `Could not load scene with ID ${selectedValue.id}.`,
          });
          return;
        }

        this.challenge = data;
        this.buildURL('challenge');
        if(this.challenge.spawners){
         for await (const spawner of this.challenge.spawners) {
          this.spawners[spawner.id] = {id: spawner.id, item: null}
         }
        }
        setTimeout(() => {
          console.log(this.spawners);
          this.spinnerService.endSpinner();
          this.challengeFetched = true;
        }, 100);

      });
    }
  }

  buildURL(type:string){
    if(type == "items"){
      console.log(this.spawners);
      let itemsArr: number[] = [];
      Object.keys(this.spawners).map((k) => {
        if(this.spawners[k] &&  this.spawners[k].item){
          itemsArr.push(this.spawners[k].item.id);
        } else {
          itemsArr.push(0);
        }
      });
      console.log(itemsArr.join('-'));
      this.sceneRenderURL = `${this.urlPrefix}/${this.challenge.id}/1024/${itemsArr.join('-')}.jpg`;
    } else {
      this.sceneRenderURL = `${this.urlPrefix}/${this.challenge.id}/1024/0.jpg`;
    }
    console.log(this.sceneRenderURL);
  }

  /**
   * Handle Enter key press.
   * Redirects to advance search page.
   *
   * @param event Browser event
   */
  onEnterPress(event: any)
  {
    if(event.key == 'Enter')
    {
      console.log(event);
    }
  }

  async spawnerChange(event: any, spawnerId: number ){
    this.buildURL('items');
    console.log('spawnerChange: ', event, spawnerId);
  }

  scroll(where: string){
    console.log('scrolling');
    window.scroll({
      top: document.body.scrollHeight,
      left: 100,
      behavior: 'smooth'
    });
  }
}
